import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow,
  Paper, Container, IconButton, Box, TextField, Typography,
  TablePagination
} from "@mui/material";
import { Download } from "@mui/icons-material";
import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Material() {
  const url_list = Config.api_domain + "/events/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        console.log("API Response:", data);

        const receivedData = Array.isArray(data.data) ? data.data : [];

        // Urutkan data berdasarkan time_uploaded (terbaru ke terlama)
        const sortedData = [...receivedData].sort(
          (a, b) => new Date(b.time_uploaded) - new Date(a.time_uploaded)
        );

        setList(sortedData);

      } catch (error) {
        console.error("Fetch error:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title?.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const slicedData = filteredList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>
        <h3>Materials</h3>

        <Box display="flex" justifyContent="flex-end" mb={2}>
          <TextField
            size="small"
            label="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(0);
            }}
          />
        </Box>

        {loading ? (
          <Typography>Loading data...</Typography>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 500 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>No</StyledTableCell>
                    <StyledTableCell>Event List</StyledTableCell>
                    <StyledTableCell>Publication Date</StyledTableCell>
                    <StyledTableCell>Download</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {slicedData.length === 0 ? (
                    <StyledTableRow>
                      <StyledTableCell colSpan={4}>
                        {list.length === 0 ? "No data available" : "No matching records found"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    slicedData.map((row, index) => {
                      const formattedDate = dateToStringDate(new Date(row.time_uploaded));
                      return (
                        <StyledTableRow key={row.public_id || index}>
                          <StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>
                          <StyledTableCell>{row.title}</StyledTableCell>
                          <StyledTableCell>{formattedDate}</StyledTableCell>
                          <StyledTableCell>
                            <IconButton
                              aria-label="download"
                              component="a"
                              href={`${Config.api_domain}/events/download/${row.public_id}`}
                              download
                            >
                              <Download />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Show entries"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
            />
          </>
        )}
      </Container>
    </div>
  );
}

export default Material;
